import React, { useEffect } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { appTitle } from "./common/GeneralConfigurations";
import { AppRoutes } from "../AppRoutes";

const ForbiddenPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = `${appTitle} - ${t("forbiddenPage.title")}`;
  }, [t]);

  return (
    <div
      id="main"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: "30%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        margin: 0,
        padding: 0,
      }}
    >
      <div
        className="text-center"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <h1 style={{ margin: 0 }}>{t("forbiddenPage.title")}</h1>
        <h6 style={{ margin: 0 }}>{t("forbiddenPage.description")}</h6>
        <Button
          type="primary"
          onClick={() => navigate(AppRoutes.home.path)}
          className="adn-primary-button"
          style={{ marginTop: "10px", fontWeight: 500 }}
        >
          {t("forbiddenPage.backToHome")}
        </Button>
      </div>
    </div>
  );
};

export default ForbiddenPage;
